// extracted by mini-css-extract-plugin
module.exports = {"content":"Login_content__2LFvN","message":"Login_message__2sAhj"};